import React from "react";
import { H2, MediumText } from "../../../../Assets/Styles/GlobleStyles/TextStyles";
import { useTheme } from "@mui/material/styles";
import styled from "styled-components";

export default function ScrollCard () {
    const theme = useTheme();
    const ContentWrapper = styled.div`
    padding: 0px 27px 27px 27px;
    display: grid;
    grid-template-columns: 400px auto;
    gap: 30px;
    border: 2px solid #ffffff;
    border-radius: 20px;
    background: ${theme.palette.primary.main};

    @media (max-width: 1325px) {
        grid-template-columns: 300px auto;
        gap: 20px;
        padding: 0px 20px 20px 20px;
    }

    @media (max-width: 1160px) {
        display: flex;
        flex-direction: column;
        padding: 20px 15px 20px 15px;
        gap: 15px;
    }

    @media (max-width: 768px) {
        padding: 15px 10px 15px 10px;
        gap: 10px;
        border-radius: 15px;
    }

    @media (max-width: 480px) {
        padding: 10px 8px 10px 8px;
        gap: 8px;
        border-radius: 12px;
    }

    @media (max-width: 375px) {
        gap: 5px;
        border-radius: 10px;
    }

    @media (max-width: 320px) {
        gap: 3px;
        border-radius: 8px;
    }
`
const BoxHighlight = styled.span`
    font-size: 56px;
    color: ${theme.palette.secondary.main};
    display: inline-block;
    line-height: 1;

    @media (max-width: 1290px) {
        font-size: 48px;
    }

    @media (max-width: 1160px) {
        font-size: 42px;
    }

    @media (max-width: 768px) {
        padding-top: 5px;
        font-size: 36px;
    }

    @media (max-width: 480px) {
        font-size: 30px;
    }

    @media (max-width: 375px) {
        font-size: 26px;
    }

    @media (max-width: 320px) {
        font-size: 24px;
    }
`

const Box = styled.div`
    border: 1px solid #FFFFFF;
    max-width: 410px;
    height: 100px;
    place-items: center;
    margin: 0 auto;
    padding: 27px 27px 40px 27px;
    background: ${theme.palette.primary.main};
    display: flex;
    align-items: center;
    justify-content: center;
    
    @media (max-width: 2001px) {
        padding: 27px;
    }

    @media (max-width: 1510px) {
        padding: 27px 27px 40px 27px;
    }

    @media (max-width: 1160px) {
        max-width: 100%;
        height: auto;
        min-height: 80px;
        padding: 20px 15px 25px 15px;
    }

    @media (max-width: 768px) {
        min-height: 70px;
        padding: 15px 10px 20px 10px;
    }

    @media (max-width: 480px) {
        min-height: 60px;
        padding: 12px 8px 15px 8px;
    }

    @media (max-width: 420px) {
        min-height: 55px;
        padding: 10px 5px 12px 5px;
    }

    @media (max-width: 375px) {
        min-height: 50px;
        padding: 8px 3px 10px 3px;
    }

    @media (max-width: 320px) {
        min-height: 45px;
        padding: 6px 2px 8px 2px;
    }
`
const BoxTitle = styled(H2)`
    font-size: 36px;
    color: #FFFFFF;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    line-height: 1.2;
    margin: 0;
    padding: 0;

    @media (max-width: 1290px) {
        font-size: 32px;
    }

    @media (max-width: 1160px) {
        font-size: 28px;
    }

    @media (max-width: 768px) {
        font-size: 24px;
    }

    @media (max-width: 480px) {
        font-size: 20px;
    }

    @media (max-width: 420px) {
        font-size: 18px;
    }

    @media (max-width: 375px) {
        font-size: 16px;
    }
`;

const BoxDescription = styled(MediumText)`
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 1.3;
    margin: 0;
    padding: 0;

    @media (max-width: 1160px) {
        font-size: 16px;
    }

    @media (max-width: 768px) {
        font-size: 14px;
    }
`

    return(
        <Wrapper>
            <ContentWrapper>
                <Title>
                <span style={{color: '#FFFFFF'}}>The global pet industry...</span>
                </Title>
                <BoxWrapper>
                    <BodySection>
                        <BoxDetailWrapper>
                            <Box>
                                <BoxDetails>
                                    <BoxTitle><span>$</span><BoxHighlight>260+</BoxHighlight> Billion</BoxTitle>
                                    <BoxDescription>global pet industry valuation as of 2023</BoxDescription>
                                </BoxDetails>
                            </Box>
                        </BoxDetailWrapper>
                        <BoxDetailWrapper>
                            <Box>
                                <BoxDetails>
                                    <BoxTitle><BoxHighlight>80</BoxHighlight> Million+</BoxTitle>
                                    <BoxDescription>households with a pet</BoxDescription>
                                </BoxDetails>
                            </Box>
                        </BoxDetailWrapper>
                    </BodySection>
                    <BodySection>
                        <BoxDetailWrapper>
                            <Box>
                                <BoxDetails>
                                    <BoxTitle><BoxHighlight>4</BoxHighlight> Million</BoxTitle>
                                    <BoxDescription>animals travel via airplane worldwide</BoxDescription>
                                </BoxDetails>
                            </Box>
                        </BoxDetailWrapper>
                        <BoxDetailWrapper>
                            <Box>
                                <BoxDetails>
                                    <BoxTitle><BoxHighlight>23</BoxHighlight> Million</BoxTitle>
                                    <BoxDescription>pets rescued during COVID-19 pandemic</BoxDescription>
                                </BoxDetails>
                            </Box>
                        </BoxDetailWrapper>
                    </BodySection>
                    <BodySection>
                        <BoxDetailWrapper>
                            <Box>
                                <BoxDetails>
                                    <BoxTitle>$<BoxHighlight>114</BoxHighlight> Billion</BoxTitle>
                                    <BoxDescription>spent on vet bills each year worldwide</BoxDescription>
                                </BoxDetails>
                            </Box>
                        </BoxDetailWrapper>
                        <BoxDetailWrapper>
                            <Box>
                                <BoxDetails>
                                    <BoxTitle><BoxHighlight>20%</BoxHighlight></BoxTitle>
                                    <BoxDescription>of the global population subscribe to pet related product boxes</BoxDescription>
                                </BoxDetails>
                            </Box>
                        </BoxDetailWrapper>
                    </BodySection>   
                    <BodySection>
                        <BoxDetailWrapper>
                            <Box>
                                <BoxDetails>
                                    <BoxTitle><BoxHighlight>22%</BoxHighlight></BoxTitle>
                                    <BoxDescription>increase in call volumes and over 401,550 calls related to pet exposures to toxic substances</BoxDescription>
                                </BoxDetails>
                            </Box>
                        </BoxDetailWrapper>
                        <BoxDetailWrapper>
                            <Box>
                                <BoxDetails>
                                    <BoxTitle><BoxHighlight>6.3</BoxHighlight> Million</BoxTitle>
                                    <BoxDescription>animals enter shelters each year</BoxDescription>
                                </BoxDetails>
                            </Box>
                        </BoxDetailWrapper>
                    </BodySection>
                </BoxWrapper>
            </ContentWrapper>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    margin: 0 auto;
    overflow: hidden;
    padding: 50px 0px;
    padding-bottom: 0px;

    @media (max-width: 768px) {
        padding: 30px 0px 0px;
    }

    @media (max-width: 480px) {
        padding: 20px 0px 0px;
    }

    @media (max-width: 375px) {
        padding: 15px 0px 0px;
    }

    @media (max-width: 320px) {
        padding: 10px 0px 0px;
    }
`

const Title = styled.p`
    font-weight: bold;
    font-size: 36px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    line-height: 1.3;
    display: flex;
    text-align: center;
    justify-content: center;
    height: 100%;
    align-items: center;
    margin: 0;
    padding: 0;

    @media (max-width: 1290px) {
        font-size: 34px;
        padding-top: 20px;
    }

    @media (max-width: 1160px) {
        text-align: center;
        font-size: 28px;
    }

    @media (max-width: 768px) {
        font-size: 24px;
    }

    @media (max-width: 480px) {
        font-size: 20px;
    }

    @media (max-width: 375px) {
        font-size: 18px;
    }

    @media (max-width: 320px) {
        font-size: 16px;
    }
`

const BoxWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0px 35px;

    @media (max-width: 1290px) {
        gap: 0px 20px;
    }

    @media (max-width: 1160px) {
        gap: 0px 15px;
    }

    @media (max-width: 728px) {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    @media (max-width: 480px) {
        gap: 8px;
    }

    @media (max-width: 375px) {
        gap: 5px;
    }
`

const BodySection = styled.div`
    @media (max-width: 855px) {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    @media (max-width: 480px) {
        gap: 8px;
    }

    @media (max-width: 375px) {
        gap: 5px;
    }
`

const BoxDetailWrapper = styled.div`
    margin-top: 27px;

    @media (max-width: 1160px) {
        margin-top: 20px;
    }

    @media (max-width: 768px) {
        margin-top: 15px;
    }

    @media (max-width: 480px) {
        margin-top: 10px;
    }

    @media (max-width: 375px) {
        margin-top: 8px;
    }

    @media (max-width: 320px) {
        margin-top: 5px;
    }
`

const BoxDetails = styled.div`
    justify-content: space-around;
    line-height: 1.2;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    @media (max-width: 768px) {
        line-height: 1.2;
    }

    @media (max-width: 480px) {
        line-height: 1.1;
    }
`



